import Helpers from "./helpers";

declare global {
	interface Window { __lc: any; }
}
declare var LC_API: any;

export default class LiveChat {

	private hasInteractedWithLiveChat: boolean;
	private liveChatFacade: HTMLElement;

	constructor() {
		this.init();
	}

	private setCustomVariables() {
		const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
		const isTablet = /iPad|Android(?!.*Mobile)|Kindle|Silk|PlayBook|BB10.*Touch/i.test(navigator.userAgent);
		const isMobilePhone = hasTouch && window.innerWidth < 768 && !isTablet;
		LC_API.set_custom_variables([
			{ name: "proactive", value: false },
			{ name: "isMobile", value: isMobilePhone },
			{ name: "isTrade", value: Helpers.searchDataLayer('customerGroup').toLowerCase().indexOf("trade") !== -1 }
		]);
	}

	private init() {
		this.liveChatFacade = document.querySelector('.js-live-chat-facade');
		if (!this.liveChatFacade) {
			return;
		}
		this.hasInteractedWithLiveChat = sessionStorage.getItem('live-chat-interacted') !== null;
		if (this.hasInteractedWithLiveChat) {
			this.loadLiveChatScript();
			const interval = setInterval(() => {
				if (typeof LC_API !== "undefined" && LC_API.is_loaded()) {
					clearInterval(interval);
					this.setCustomVariables();
				}
			}, 50);
			if (this.liveChatFacade) {
				this.liveChatFacade.remove();
			}
		} else {
			this.attachButtonClick();
			this.liveChatFacade.classList.add('is-active');
		}
	}

	private attachButtonClick() {
		if(!this.liveChatFacade) return;
		this.liveChatFacade.addEventListener("click", () => {
			this.loadLiveChatScript();
			const facadeText = document.querySelector('.js-live-chat-facade-text');
			if (facadeText) {
				facadeText.textContent = "Opening chat...";
			}
			this.liveChatFacade.classList.add('is-loading');
			// Poll for the chat window to be ready
			const interval = setInterval(()=> {
				if (typeof LC_API !== "undefined" && LC_API.is_loaded()) {
					clearInterval(interval);
					this.liveChatFacade.remove();
					LC_API.open_chat_window();
					this.setCustomVariables();
					sessionStorage.setItem('live-chat-interacted', 'true');
				}
			}, 50);
		}, { once: true });
	}

	private loadLiveChatScript() {
		window.__lc = window.__lc || {};
		window.__lc.license = 11125067;
		(function () {
			var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true;
			lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js';
			var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
		})();

		const interval = setInterval(() => {
			if (typeof LC_API !== "undefined" && typeof LC_API.is_loaded === "function" && LC_API.is_loaded()) {
				clearInterval(interval);
				setTimeout(() => {
					document.documentElement.classList.add('show-live-chat');
					this.setCustomVariables();
					LC_API.on_chat_window_minimized = function () {
						document.documentElement.classList.remove('show-live-chat');
						setTimeout(() => {
							document.documentElement.classList.add('show-live-chat');
						}, 1000);
					};
				}, 250);
			}
		}, 50);
	}

}
